module.exports = __webpack_public_path__ + "img/cy.a9f33b22.jpg";